<div class="dtp-popup-container">
    <div class="dtp-popup-header">
        <div [ngClass]="{'dtp-btn-disabled':getYearAndMonth(minMonth)>=getYearAndMonth(viewDate)}" mwlCalendarPreviousView [view]="view" [viewDate]="viewDate || nowDate" (viewDateChange)="viewDateChange($event)">
            <i class="fa fa-chevron-left poi"></i>
        </div>
        <div class="dtp-popup-title">
            <span class="com-title-month"
                (click)="showMonthPopup=true;">{{viewDate | date:'MMMM' }}</span><span class="com-title-year"
                (click)="showYearPopup=true;">{{viewDate|date:'yyyy'}}</span>
        </div>
        <div [ngClass]="{'dtp-btn-disabled':getYearAndMonth(viewDate)>=getYearAndMonth(maxMonth)}" mwlCalendarNextView [view]="view" [viewDate]="viewDate" (viewDateChange)="viewDateChange($event)">
            <i class="fa fa-chevron-right poi"></i>
        </div>
    </div>
    <div class="dtp-popup-calendar">
        <mwl-calendar-month-view #calendar [viewDate]="viewDate" (dayClicked)="dayClick($event.day)" 
        (beforeViewRender)="beforeMonthViewRender($event)">
        </mwl-calendar-month-view>
    </div>
    <div class="com-month-year-popup" *ngIf="showMonthPopup||showYearPopup">
        <ad-month-picker *ngIf="showMonthPopup" [max]="maxDate" [min]="minDate" [currentDate]="viewDate" (onSelect)="monthSelect($event)"></ad-month-picker>
        <ad-year-picker *ngIf="showYearPopup" [max]="maxYear" [min]="minYear" (onSelect)="yearSelect($event)" [currentDate]="viewDate"></ad-year-picker>
    </div>
</div>